// extracted by mini-css-extract-plugin
export default {"color-black":"#000000","colorBlack":"#000000","large":"only screen and (min-width: 992px)","item":"nLUCi _2AZKg _3cgKO","icon":"B6d0R","label":"_3p1aE"};